export enum FollowerStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Blocked = 'blocked',
}
